// extracted by mini-css-extract-plugin
export default {"label":"swvsHqkmncIUKfbPuM1V"};